// ChoiceUtils.js
// improve on setTimeout -- use timeout(1000).then(() => timeOutFunction());
export async function timeout(millisecToWait: number): Promise<void>
{
    return new Promise((resolve, reject) => {
        setTimeout(() => 
                { 
                    resolve(); 
                }, 
                millisecToWait);
    });
}

// improve on setInterval -- use interval(1000).then(() => intervalFunction());
export async function interval(millisecToWait: number): Promise<void>
{
    return new Promise((resolve, _reject) => {
        setInterval(() => 
                { 
                    resolve(); 
                }, 
                millisecToWait);
    });
}

export function randomId(length = 12) : string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

export function cookiesDictionary(): Record<string, string> {
    // Get the cookies string and split into parts based on the ";" delimit
    const cookiesMap = window.document.cookie.split(";").map(cookieItem => {

        // Split on the first "=" to get the name and data
        const posOfDelimit = cookieItem.indexOf('=');
        return [cookieItem.slice(0, posOfDelimit).trim(), cookieItem.slice(posOfDelimit + 1).trim()];
    });

    const cookieDict: Record<string, string> = {};
    for (const cookieItem of cookiesMap) {
        const cookieTuple = cookieItem;
        cookieDict[cookieTuple[0]] = cookieTuple[1];
    }
    return cookieDict;
}

export function LogInInfo(){
    // Is the Login info in session storage?
    let loginInfo = sessionStorage.getItem("LogInInfo");

    // FUTURE: Fallback to cookies until we full implement better session storage solution
    if (null == loginInfo)
        loginInfo = cookiesDictionary()["LogInInfo"];

    return loginInfo;
}

export function currentLogInParts() : Record<string, string> | undefined {
    const loginInfo = LogInInfo();
    if (!loginInfo)
        return;

    const parts = loginInfo.split("&").map(part => part.split("="));

    const loginDict: Record<string, string> = {};
    for (const part of parts) {
        loginDict[part[0]] = decodeURI(part[1]);
    }
    return loginDict;
}

//----
// TODO: refactor these
//----

// Get the currently logged in user
export const currentChoiceUser = () => currentChoiceData("V1");

// Indicate if the user is a bang user
export const isBangUser = (): boolean => currentChoiceUser()?.startsWith("!") ?? false;

// Get the currently logged in user guid
export const currentChoiceUserSessionGuid = () => currentChoiceData("V2");

// Get the currently logged in db
export const currentChoiceDatabaseKey = () => currentChoiceData("V3");

// Get the database name from the cookie
export function currentChoiceDatabase(): string|undefined
{
    const loginKey = currentChoiceUserSessionGuid();
    if ((loginKey?.length ?? 0) < 40)
        return;

    const splitValues = loginKey?.split(".");
    if (!splitValues)
        return;
    if (splitValues.length < 3)
        return;

    return splitValues[2];
}

//----

function currentChoiceData(input: "V1"|"V2"|"V3"){
    const loginInfo = currentLogInParts();
    if (!loginInfo)
        return;
    return loginInfo[input];}

// Generate a GUID (UUID v4)
export function newGuid(): string {
    const randomValueArray = new Uint32Array(32);
    self.crypto.getRandomValues(randomValueArray);
    const HexValueDict: Record<number, string> = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };

    let result = "";
    for (let j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20)
            result += '-';

        const randValue = randomValueArray[j] % 16;
        if (randValue < 10)
        {
            result += randValue + "";
            continue;
        }

        result += HexValueDict[randValue];
    }
    return result;
}

export function IsDefined(variable: any): variable is {} {
    return 'undefined' !== typeof variable;
}

export function isValidUrl(url: string): boolean {
    // URL must contain either http:// or https:// ...
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

export function htmlDecode(encodedHtml: string|undefined): string|undefined
{
    if (!encodedHtml)
        return;

    const textArea = document.createElement('textarea');
    textArea.innerHTML = encodedHtml;
    return textArea.value;
}